import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';

import { ModifyingSpan } from './style';

const ModifyButton: React.FC<{
  isModified: boolean;
  modifyFn: () => void;
}> = React.memo(({ isModified, modifyFn }) => {
  return (
    <>
      {isModified ? (
        <ModifyingSpan>修正中</ModifyingSpan>
      ) : (
        <Button
          size="xs"
          bgColor="secondary"
          outline
          height="36px"
          width="72px"
          radius="m"
          onClick={() => modifyFn()}
        >
          修正する
        </Button>
      )}
    </>
  );
});

export default ModifyButton;
